import './style.scss'
import { Dropdown, message, Modal } from 'antd'
import { FC, useEffect, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import * as Api from '@/api/home'
import { Ellipsis, Play } from '@/assets/svg'
import { urlSource } from '@/libs/util'
import { CopyOutlined } from '@ant-design/icons'
import VideoModal from '../VideoModal'

interface IProps {
  open: boolean
  onCancel?: () => void
}

const TemplateModal: FC<IProps> = (props) => {
  const { open, onCancel } = props
  const [data, setData] = useState<any[]>([])
  const [preview, setPreview] = useState<any>()
  const [activeIndex, setActiveIndex] = useState(0)
  const [openId, setOpenId] = useState<any>()

  useEffect(() => {
    getData()
  }, [activeIndex])

  const getData = async () => {
    let res
    if (activeIndex === 0) {
      res = await Api.getRecommendTemplates()
    } else {
      res = await Api.getMyTemplates()
    }
    setData(res?.list || [])
  }

  return (
    <div className="template-modal-main">
      <Modal
        title="全部模板"
        open={open}
        width="1000px"
        footer={null}
        onCancel={onCancel}
        className="commom-modal template-modal"
      >
        <div className="wrapper">
          <div className="tabs">
            <div className={`tabs-item ${activeIndex === 0 ? 'actived' : ''}`} onClick={() => setActiveIndex(0)}>
              <span>推荐</span>
            </div>
            <div className={`tabs-item ${activeIndex === 1 ? 'actived' : ''}`} onClick={() => setActiveIndex(1)}>
              <span>我的</span>
            </div>
          </div>
          <div className="list">
            {data.map((d) => (
              <div className="list-item" key={d.display_url}>
                <div
                  className={`box ${openId === d.id ? 'hovered' : ''}`}
                  onClick={() => {
                    activeIndex === 0 &&
                      setPreview({
                        url: d.demo_url,
                        title: d.title
                      })
                  }}
                >
                  <div className="img">
                    <img src={urlSource(d.cover_url, 'video')} />
                  </div>
                  <div
                    className="bg"
                    style={{
                      backgroundImage: `url(${urlSource(d.display_url, 'video')})`
                    }}
                  ></div>
                  {activeIndex === 0 && (
                    <div className="play">
                      <Play />
                    </div>
                  )}

                  <div className="op" onClick={(e) => e.stopPropagation()}>
                    <Dropdown
                      menu={{
                        items: [
                          {
                            key: '0',
                            label: (
                              <CopyToClipboard
                                text={d.template}
                                onCopy={() => {
                                  message.success('已复制')
                                }}
                              >
                                <div className="dropdown-list">
                                  <CopyOutlined />
                                  复制模板ID
                                </div>
                              </CopyToClipboard>
                            )
                          }
                        ]
                      }}
                      placement="bottom"
                      open={openId === d.id}
                      onOpenChange={(open) => {
                        setOpenId(open ? d.id : undefined)
                      }}
                    >
                      <div className="btn" onClick={(e) => e.stopPropagation()}>
                        <Ellipsis />
                      </div>
                    </Dropdown>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>

      <VideoModal preview={preview} onCancel={() => setPreview(undefined)} />
    </div>
  )
}

export default TemplateModal
